import { maxRule, minRule, numberRule } from "@mongez/react-form";
import { BaseInput, type BaseInputProps } from "./BaseInput";

type NumberInputProps = BaseInputProps;

export function NumberInput(props: NumberInputProps) {
  return (
    <BaseInput
      {...props}
      type="number"
      rules={[numberRule, minRule, maxRule]}
    />
  );
}
